import React, { Suspense, lazy, useLayoutEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import GoogleAnalytics from "../shared/GoogleAnalytics";
import Dashboard from "../component/Dashboard";
import CONFIG from "../shared/constants/config";

// Keep the primary landing screen eagerly loaded for best LCP and UX
import Home from "../screen/home";

// Remove pre-react LCP shell on non-Home routes (Home moves the img into its layout)
function LcpShellManager() {
  const location = useLocation();
  useLayoutEffect(() => {
    const isHome = location.pathname === '' || location.pathname === '/ludo-superstar-home';
    if (!isHome) {
      document.getElementById('pre-react-lcp')?.remove();
    }
  }, [location.pathname]);
  return null;
}

// Lazily load non-critical / secondary screens so their JS is not downloaded
// on initial load, improving performance (especially on mobile) without
// changing the UI or styles of those pages.
const Event = lazy(() => import("../screen/event"));
const TopPlayer = lazy(() => import("../screen/topPlayers"));
const Updates = lazy(() => import("../screen/updates"));
const HelpCenter = lazy(() => import("../screen/helpCenter"));
const TipsandTricks = lazy(() => import("../screen/tipsandtricks"));
const Tipsblog = lazy(() => import("../screen/tipsblog"));
const About = lazy(() => import("../screen/about"));
const Contact = lazy(() => import("../screen/contact"));
const Company = lazy(() => import("../screen/company"));
const TermsOfService = lazy(() => import("../screen/termsOfService"));
const Privacy = lazy(() => import("../screen/privacy"));

function AppRoutes() {
  const baseFolder = CONFIG.BASE_FOLDER;
  return (
    <Router basename={`/${baseFolder}`}>
      <GoogleAnalytics />
      <LcpShellManager />
      <Dashboard />
      <Suspense fallback={null}>
        <Routes>
          {/* Index = home: avoids extra client-side redirect that delayed first Home paint (LCP). */}
          <Route index element={<Home />} />
          <Route path={`/ludo-superstar-home`} element={<Home />} />
          <Route path={`/ludo-events`} element={<Event />} />
          <Route path={`/top-ludo-players`} element={<TopPlayer />} />
          <Route path={`/ludo-tips-and-tricks`} element={<TipsandTricks />} />
          <Route path={`/ludo-tips-blog/:slug`} element={<Tipsblog />} />
          <Route path={`/ludo-updates`} element={<Updates />} />
          <Route path={`/ludo-help-center`} element={<HelpCenter />} />
          <Route path={`/about-ludo-superstar`} element={<About />} />
          <Route path={`/contact-ludo-superstar`} element={<Contact />} />
          <Route path={`/blacklight-studio-games`} element={<Company />} />
          <Route path={`/terms-of-service`} element={<TermsOfService />} />
          <Route path={`/privacy-policy`} element={<Privacy />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default AppRoutes;